import type { ComponentProps, ReactNode } from 'react';
import { Toggle, ToggleLabel, ToggleSwitch } from '@frameio/vapor';
import { SettingRow } from './SettingRow';
import styles from './SettingRowToggle.module.css';

export const SettingRowToggle = ({
  checked,
  label,
  onChange,
  ...rest
}: {
  /** Display label for the toggle row. */
  label: ReactNode;
  /** Called when the toggle state changes. */
  onChange: (checked: boolean) => void;
} & Omit<ComponentProps<typeof Toggle>, 'onChange'>) => {
  return (
    <Toggle
      checked={checked}
      onChange={(e) => onChange(e.target.checked)}
      {...rest}
    >
      <SettingRow
        field={
          <div className={styles.switchContainer}>
            <ToggleSwitch />
          </div>
        }
        title={<ToggleLabel>{label}</ToggleLabel>}
      />
    </Toggle>
  );
};
